import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { LookupValueFormatter, FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'
import _ from 'common-tools/LodashHelper'

class StaticBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    options: pt.array,
    valueProp: pt.string,
    textProp: pt.string
  })

  static defaultProps = {
    valueProp: 'Value',
    textProp: 'Text',
    options: []
  }

  render () {
    const { options, valueProp, textProp, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) =>
          <Input type='text' readOnly invalid={showError} name={`static${name}`} id={`static${name}`} placeholder={placeHolder}
            value={LookupValueFormatter(options, value).Text} />
        }
      </FieldLayoutBox>
    )
  }
};

export const StaticBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={StaticBoxClass} /> } // eslint-disable-line
export default StaticBox
